export default "__VITE_ASSET__KVeUYBy___"